KSU.insertAdvisory = function(campus, baseurl) {

    "use strict";

    var opts = {format: "jsonp"};

    if (campus) {
        opts.campus = campus;
    }

    baseurl = (baseurl || "https://advisories.ksucloud.net/api/") + "?callback=?";
    $.getJSON(baseurl, opts)

        .done(function(data) {
            var html = [], closed = [];
            if (data && data[0] && data[0].title) {

                html.push("<div class='container-fluid ksu-advisory'>" +
                            "<div class='row ksu-row ksu-row-center'>" +
							"<div class='col-sm-2 hidden-xs-down'><img src='//www.k-state.edu/images/advisory.png' alt=''/></div>" +
							"<div class='col-sm-10'>");

                $.each(data, function(key, val) {
                    html.push("<h3><a href='http://www.k-state.edu/advisories/'>" + val.title + "</a></h3>");

                    if (val.manhattan_closed) {
                        closed.push("<li>Manhattan campus is closed</li>");
                    }

                    if (val.salina_closed) {
                        closed.push("<li>Salina campus is closed</li>");
                    }

                    if (val.olathe_closed) {
                        closed.push("<li>Olathe campus is closed</li>");
                    }

                    if (closed.length) {
                       html.push("<ul class='ksu-adv-closed'>" + closed.join("") + "</ul>");
                    }

                    html.push("<p class='ksu-adv-summary'>" + val.summary.replace(/\n/g,'<br />') + "</p>");
                });

                html.push("</div></div></div>");

                $("#insert-advisory").html(html.join(""));
            }
        }
    );
};
